const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Resolve image URL to always use the current backend URL.
 * Handles:
 * - Relative paths: /api/files/... → full URL
 * - Old hardcoded preview URLs → rewritten to current backend
 * - External URLs (https://images.unsplash.com/...) → unchanged
 */
export function resolveImageUrl(url) {
  if (!url) return '';
  
  // Already a relative path starting with /api/
  if (url.startsWith('/api/')) {
    return `${API_URL}${url}`;
  }
  
  // Old hardcoded URL pointing to preview or any emergentagent domain
  const apiFilesMatch = url.match(/https?:\/\/[^/]+(.preview\.emergentagent\.com|\.emergentagent\.com)(\/api\/files\/.+)/);
  if (apiFilesMatch) {
    return `${API_URL}${apiFilesMatch[2]}`;
  }
  
  // External URL (unsplash, etc.) - return as-is
  return url;
}
